import { createSlice } from '@reduxjs/toolkit'
import { MODALS, MULTI_INSTANCE_MODALS } from '../../constants/modals'

const initialState = {
  modals: []
}

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (state, action) => {
      try {
        if (!action.payload?.name) {
          throw new Error('Modal name is required. Please provide a unique name for the modal.')
        }

        // Check if the name is one of the values from the MODALS constant
        const validModalNames = Object.values(MODALS)
        const modalName = action.payload.name
        if (!validModalNames.includes(modalName)) {
          throw new Error(`Invalid modal name: ${modalName}. Modal name must be one of the values from the MODALS constant: ${validModalNames.join(', ')}`)
        }

        // Prevent pushing duplicate entries for the same modal name unless explicitly allowed
        const allowMultiple = MULTI_INSTANCE_MODALS.includes(modalName)
        if (!allowMultiple) {
          const alreadyOpen = state.modals.some(modal => modal.name === modalName)
          if (alreadyOpen) return
        }

        state.modals.push({
          isOpen: true,
          name: modalName,
          modalType: action.payload.modalType || null,
          modalProps: action.payload.modalProps || {},
          graphic: action.payload.graphic || null,
          title: action.payload.title || '',
          body: action.payload.body || null,
          buttons: action.payload.buttons || [],
          onClose: action.payload.onClose
        })
      } catch (e) {
        console.error(e)
      }
    },
    closeModal: (state, action) => {
      try {
        // Close the modal with the given name
        // If no name is provided, throw an error and do nothing
        if (!action.payload) {
          throw new Error('Modal name is required for closeModal action. Please provide the name of the modal to close.')
        } else {
          // Find the modal with the given name
          const modalIndex = state.modals.findIndex(modal => modal.name === action.payload)
          if (modalIndex !== -1) {
            state.modals.splice(modalIndex, 1)
          }
        }
      } catch (e) {
        console.error(e)
      }
    },
    closeAllModals: (state) => {
      state.modals = []
    }
  }
})

export const {
  openModal,
  closeModal,
  closeAllModals
} = modalSlice.actions

export default modalSlice.reducer
